/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Table, theme } from "@nordcloud/gnui";
import { TRANSITION } from "~/constants/theme";

export const InputWrap = styled.div`
  width: 5rem;
  padding: 0 ${theme.spacing.spacing04};
`;

export const Footer = styled.div`
  padding: ${theme.spacing.spacing04};
  display: flex;
  justify-content: space-between;
  flex: 1;
`;

export const SwitchWrap = styled.div`
  display: inline-block;
`;

export const StyledTd = styled(Table.td)`
  text-align: right;
`;

export const StyledTr = styled(Table.tr)<{ show?: boolean }>`
  display: ${({ show }) => (show ? "table-row" : "none")};
  background: ${theme.color.background.ui03};

  &:last-child > td {
    padding-bottom: ${theme.spacing.spacing05};
  }
`;

export const TdWithMinWidth = styled(Table.td)`
  min-width: ${theme.spacing.spacing04};
  max-width: ${theme.spacing.spacing04};
  width: ${theme.spacing.spacing04};
  cursor: pointer;
`;

export const OptionInner = styled.div`
  margin-left: ${theme.spacing.spacing04};
  width: 60%;
`;

export const Option = styled.div<{ selected: boolean; withHover: boolean }>`
  background: ${({ selected }) =>
    selected ? theme.color.background.ui04 : theme.color.background.ui01};
  border: 1px solid ${theme.color.border.border01};
  padding: ${theme.spacing.spacing04};
  margin-bottom: ${theme.spacing.spacing04};
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: flex-start;
  border-radius: ${theme.radius.md};
  transition: ${TRANSITION.default};
  cursor: pointer;

  &:hover {
    background-color: ${({ withHover }) =>
      withHover ? theme.color.interactive.secondaryHover : undefined};
  }
`;

export const ButtonCss = {
  fontSize: theme.fontSizes.md,
  color: theme.color.interactive.link,

  "&:hover": {
    cursor: "pointer",
    textDecoration: "underline",
  },
};
